import { errorTypes } from 'catering/constants/errors';

export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_SERVICE = 'online_ordering';
export const KNOWN_ERROR_CODES = [errorTypes.ITEM_NOT_ON_MENU];
export const KNOWN_ERROR_MESSAGES = [
  'No fulfillment hours found within 12 months',
  'This item is not available at this time.'
];
